"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { Messages } from "Messages";
import { System } from "Constants/objects";

var EditButtonProps =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(EditButtonProps, _BaseToolbarButtonPro);

  function EditButtonProps(_ref) {
    var _this;

    var type = _ref.type,
        isContextMenu = _ref.isContextMenu,
        title = _ref.title,
        onMouseDown = _ref.onMouseDown,
        rest = _objectWithoutProperties(_ref, ["type", "isContextMenu", "title", "onMouseDown"]);

    _classCallCheck(this, EditButtonProps);

    var _System$TOOLBAR_BTN_C = System.TOOLBAR_BTN_CLASSES,
        EDIT = _System$TOOLBAR_BTN_C.EDIT,
        MULTI_EDIT = _System$TOOLBAR_BTN_C.MULTI_EDIT;

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: title || Messages.Controls.Edit,
      hint: title || Messages.Controls.Edit,
      disabled: true,
      elementAttr: {
        'class': type === System.BUTTON_TYPE.MULTI_EDIT ? MULTI_EDIT : EDIT
      }
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EditButtonProps).call(this, props));

    _this.setOptions({
      iconType: _this.getOptions().iconType || 'fontawesome:far fa-edit',
      mouseDown: _this.getOptions().mouseDown || onMouseDown
    });

    return _this;
  }

  _createClass(EditButtonProps, [{
    key: "onMouseDown",
    value: function onMouseDown(element) {
      var _this$getOptions = this.getOptions(),
          mouseDown = _this$getOptions.mouseDown;

      if (typeof mouseDown === "function") {
        $(element).off('mousedown');
        $(element).on('mousedown', function (e) {
          mouseDown(e);
        });
      }
    }
  }]);

  return EditButtonProps;
}(BaseToolbarButtonProp);

_defineProperty(EditButtonProps, "create", function (options) {
  return new EditButtonProps(options).props();
});

export { EditButtonProps as default };